import { Controller } from "@hotwired/stimulus"
import { LogoHelper } from "~/helpers/logo_helper"

export default class extends Controller {
  static get targets() {
    return ["input", "logo", "company", "domain", "logoUrl", "copyButton", "loader"]
  }

  connect() {
    // Initialize with default values
    this.updateDisplay("hunter.io", "Hunter")
    this.debounceTimeout = null
  }

  submit(event) {
    // Prevent form submission when Enter is pressed
    event.preventDefault()
  }

  disconnect() {
    // Clear any pending debounce timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  input(event) {
    const inputValue = event.target.value.trim()

    // Clear previous timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    if (!inputValue) {
      // Reset to default if input is empty
      this.hideLoader()
      this.updateDisplay("hunter.io", "Hunter")
      return
    }

    // Debounce the API call to avoid too many requests
    this.debounceTimeout = setTimeout(() => {
      this.processInput(inputValue)
    }, 300)
  }

  processInput(inputValue) {
    // Extract domain from input
    const domainName = App.hostnameFromURL(inputValue)

    // Check if it's a valid domain
    if (App.isADomainName(domainName)) {
      // Show loader and fetch all data from API
      this.showLoader()
      this.fetchDomainData(domainName)
    } else {
      // Hide loader if domain is not valid
      this.hideLoader()
    }
  }

  fetchDomainData(domainName) {
    fetch(App.api.domainsSuggestion(domainName))
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then((response) => {
        // Get company name from API response or fallback to domain name
        const companyName = response.data && response.data.length > 0 ? response.data[0].name : domainName

        // Update all elements at once
        this.updateDisplay(domainName, companyName)
      })
      .catch(() => {
        // Fallback to domain name on error
        this.updateDisplay(domainName, domainName)
      })
      .finally(() => {
        // Hide loader when API call is complete
        this.hideLoader()
      })
  }

  updateDisplay(domain, companyName) {
    const logoUrl = LogoHelper.companyLogoUrl(domain)

    this.logoTarget.src = logoUrl
    this.companyTarget.textContent = companyName
    this.domainTarget.textContent = domain
    this.logoUrlTarget.textContent = logoUrl
    this.copyButtonTarget.dataset.copyTextValue = logoUrl
  }

  showLoader() {
    this.loaderTarget.classList.add("is-visible")
  }

  hideLoader() {
    this.loaderTarget.classList.remove("is-visible")
  }
}
